import React, {useEffect, useRef} from "react";
import styled from "styled-components";
import {GreenButton} from "./ButtonStyles";

const SendFormButton = ({
                            state,
                            actionName,
                            action
                        }) => {


    const ButtonStyle = {
        backgroundColor: `${state ? '#4BB472FF' : '#52D78399'}`,
        cursor: `${state ? "pointer" : 'not-allowed'}`,
    }
    const buttonRef = useRef()

    useEffect(() => {
        buttonRef.current.disabled = !state;
    }, [state])

    const changeBackgroundButton = (e) => {
        if (e.target.tagName.toLowerCase() === "button") {
            e.target.style.backgroundColor = 'var(--color-green-06)'
        }
    }

    const changeBackgroundLeave = (e) => {
        if (e.target.tagName.toLowerCase() === "button") {
            e.target.style.backgroundColor = 'var(--color-green-darker)'
        }
    }

    return (
        <Button
            onMouseOver={changeBackgroundButton}
            onMouseLeave={changeBackgroundLeave}
            type={"submit"}
            id={"send-form-btn"}
            style={ButtonStyle}
            ref={buttonRef}
            onClick={action}
        >
            <p> {actionName} </p>
        </Button>
    )
}

const Button = styled(GreenButton)`
  width: 8em;
  align-self: center;

  p {
    font-size: 16px;
    background-color: transparent;
  }
  
`
export default SendFormButton